export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  articleCount: number;
  color: string;
}

export const categories: Category[] = [
  {
    slug: 'ecommerce',
    name: '电商优惠',
    description: '淘宝、京东、拼多多等主流电商平台优惠券、满减活动、限时折扣汇总',
    icon: 'ri-shopping-bag-3-line',
    articleCount: 28,
    color: 'primary',
  },
  {
    slug: 'membership',
    name: '会员权益',
    description: '视频会员、音乐会员、云存储会员等各类平台会员免费领取与折扣攻略',
    icon: 'ri-vip-crown-line',
    articleCount: 22,
    color: 'accent',
  },
  {
    slug: 'subsidy',
    name: '生活补贴',
    description: '话费补贴、交通补贴、餐饮优惠、租房补贴等日常生活福利汇总',
    icon: 'ri-bank-card-line',
    articleCount: 19,
    color: 'primary',
  },
  {
    slug: 'career',
    name: '职场福利',
    description: '求职补贴、技能培训、五险一金政策解读、企业福利对比指南',
    icon: 'ri-briefcase-line',
    articleCount: 16,
    color: 'accent',
  },
  {
    slug: 'freebie',
    name: '免费福利',
    description: '免费试用、免费样品申领、免费课程、免费工具等零成本福利资源',
    icon: 'ri-gift-line',
    articleCount: 25,
    color: 'primary',
  },
  {
    slug: 'finance',
    name: '金融福利',
    description: '信用卡权益、理财红包、银行贷款优惠、保险福利等金融类福利指南',
    icon: 'ri-funds-line',
    articleCount: 14,
    color: 'accent',
  },
];